// These public values are deliberately embedded in the Pages client so it can
// reject a package from a different campaign before decoding any profile data.
// They must follow the currently published, locally signed mini-app package.
export const CAMPAIGN_ID="72516f99b64b5e09fc3f235284f71845";
export const CAMPAIGN_PUBLIC_KEY="VokApBKmPyR5uMYqhzLuPLYoyeqW3Q9C7KN7Qr3d8RE";
